"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import NextError from "next/error";
import { useEffect } from "react";
import { reportRouteError } from "@/lib/observability/report-route-error";

export default function GlobalError({
	error,
}: {
	error: Error & { digest?: string };
}) {
	useEffect(
		function reportGlobalRouteError() {
			reportRouteError({
				error,
				segment: "global",
			});
		},
		[error],
	);

	return (
		<html lang="en">
			<body>
				<NextError statusCode={0} />
			</body>
		</html>
	);
}
